module.exports = __webpack_public_path__ + "img/头图.ef6f03e9.png";